import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Envelope from "@/components/Envelope";
import Invitation from "@/components/Invitation";
import FallingLeaves from "@/components/FallingLeaves";
import Admin from "@/components/Admin";
import { weddingData } from "@/mock";

const Home = () => {
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    document.body.style.overflow = opened ? "auto" : "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [opened]);

  return (
    <div className="relative min-h-screen overflow-x-hidden paper-bg text-[#1C1917]">
      <div className="glow-top" aria-hidden="true" />
      <div className="glow-bottom" aria-hidden="true" />
      <FallingLeaves count={14} />
      <Invitation data={weddingData} revealed={opened} />
      {!opened && <Envelope data={weddingData} onOpened={() => setOpened(true)} />}
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
